/** @format */

import {format, parseISO} from 'date-fns';
import {ru} from 'date-fns/locale';

import {type ActivePeriod} from 'features/mediaplan-progress/types';

/**
 * Label for the «План на …» row, derived from the active plan's period:
 *  - monthly repeatable plan → the period's month name («июнь»);
 *  - flight / weekly / anything else → the date range («9 июн. – 9 июл.»), since the period
 *    isn't a calendar month and naming a month would misrepresent the planned budget's span;
 *  - no active plan → the current month (fallback; the «План на …» row isn't shown without a plan).
 *
 * parseISO reads the date-only strings as LOCAL midnight so date-fns' local format matches the
 * intended calendar day in every timezone (see buildChartData for the same UTC-vs-local fix).
 */
export const getPlanPeriodLabel = (active: ActivePeriod | null, now: Date): string => {
  if (!active) {
    return format(now, 'LLLL', {locale: ru});
  }

  if (active.plan.repeat === 'MONTHLY') {
    return format(parseISO(active.period.start), 'LLLL', {locale: ru});
  }

  const start = format(parseISO(active.period.start), 'd MMM', {locale: ru});
  const end = format(parseISO(active.period.end), 'd MMM', {locale: ru});
  return `${start} – ${end}`;
};
